import API from '@/lib/API.js'
const comun = {
    namespaced: true,
    state: {
        sinmanejador: [true, true, true, true],
        bandejaactual: 0,
        Loading: 0,
        Usuario: undefined,
        IdUsuario: undefined,
        Permisos: [],
        Navs: {
            Autogestionbeneficiarios: [{
                    texto: "Ordenes",
                    to: "PracticasAutogestion"
                },
                {
                    texto: "Datos",
                    to: "Misdatos"
                },
                {
                    texto: "Grupo Familiar",
                    to: "GrupoFamiliar"
                },
                {
                    texto: "Credencial",
                    to: "Credencial"
                },
                {
                    texto: "Cartilla",
                    to: "CartillaAutogestion"
                },
            ],
            Micrositioprestadores: [{
                    texto: "Autorizaciones",
                    to: "AutorizacionesMicrositio"
                },
                {
                    texto: "Consultar Afiliacion",
                    to: "AfiliacionMicrositio"
                },
                {
                    texto: "Mis Datos",
                    to: "DatosMicrositio"
                },
                {
                    texto: "Contacto",
                    to: "Contacto"
                },
            ],
        },
        Snackbar: { //alerta que muestra sucesos
            mostrar: false,
            texto: '',
            color: ''
        }
    },
    mutations: {
        cargando(state) {
            state.Loading++;
        },
        fincarga(state) {
            state.Loading--;
        },
        mostrar(state, valor) {
            state.Snackbar.texto = valor;
            state.Snackbar.color = 'green lighten-3';
            state.Snackbar.mostrar = true;
        },
        ocultar(state) {
            state.Snackbar.mostrar = false;
        },
        setUsuario(state, valor) {
            state.Usuario = valor;
        },
        setIdUsuario(state, valor) {
            state.IdUsuario = valor;
        },
        setPermisos(state, valor) {
            state.Permisos = valor;
        },
        setBandeja(state, valor) {
            state.bandejaactual = valor;
        },
        setManejador(state, valor) {
            state.sinmanejador[valor] = false;
        },
    },
    actions: {
        async loguear({
            commit
        }, valor) {
            commit("cargando")
            if (valor) {
                window.localStorage.setItem('user', JSON.stringify(valor));
                commit("setUsuario", valor.Username)
                let permisos = []
                permisos = await API.Usuarios.traerPermisosDelUsuarioEnElSitio();
                window.localStorage.setItem('permisos', JSON.stringify(permisos));
                commit("setPermisos", permisos)
            }
            commit("fincarga")
            return 0;
        },
        async LoguearCartilla({
            commit
        }) {
            commit("cargando")
            let data = []
            //data = await API.Usuarios.traerUser(valor.usuario, valor.contrasena);
            data = await API.Usuarios.LoguearCartilla();
            if (data && data.Token) {
                window.localStorage.setItem('user', JSON.stringify(data));
                commit("selectUsuario", data)
            } else {
                commit("selectUsuario", undefined)
                alert("Usuario y/o Contraseña incorrecta")
            }
            commit("fincarga")
            return 0;
        },
        setBandeja({
            commit
        }, valor) {
            commit("setBandeja", valor)
        },
        setManejador({
            commit
        }, valor) {
            commit("setManejador", valor)
        },
        desloguear({
            commit,
            state
        }) {
            //  localStorage.removeItem('user')
            //  localStorage.removeItem('permisos')
            //  commit("setUsuario", undefined)
            //  commit("setPermisos", [])
            window.location.href = API.Portal;
        },
        quitarUsuario({
            commit
        }) {
            localStorage.removeItem('user')
            localStorage.removeItem('permisos')
            commit("setUsuario", undefined)
            commit("setPermisos", [])
        },
        async traerUserId({
            commit,
        }) {
            commit("cargando")
            let userid = await API.Usuarios.traerUsuarioLogueado();
            if (userid) {
                commit("setIdUsuario", userid)
            }
            commit("fincarga")
        },
        async inicializar({
            commit,
            dispatch
        }) {
            commit("cargando")
            let user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                commit("setUsuario", user.Username)
                let permisos = JSON.parse(localStorage.getItem('permisos'));
                if (permisos) {
                    commit("setPermisos", permisos)
                }
            } else {
                dispatch("desloguear");
            }
            commit("fincarga")
        },
    },
    getters: {
        getNavs: (state) => (Nav) => {
            return state.Navs[Nav];
        },
        permisoSoltar: (state) => {
            return state.Permisos.findIndex(
                (x) => x.descripcion_permiso.toUpperCase() === "SOLTARPRACTICA"
            ) > -1;
        },
        permisoAnular: (state) => {
            return state.Permisos.findIndex(
                (x) => x.descripcion_permiso.toUpperCase() === "ANULARPRACTICA"
            ) > -1;
        },
        permisoAuditoria: (state) => {
            return state.Permisos.findIndex(
                (x) => x.descripcion_permiso.toUpperCase() === "AUDITORIAMEDICA"
            ) > -1;
        },
        permisoCerrarInternacion: (state) => {
            return state.Permisos.findIndex(
                (x) => x.descripcion_permiso.toUpperCase() === "CERRARINTERNACION"
            ) > -1;
        },
        permisoCambiarPrestador: (state) => {
            return state.Permisos.findIndex(
                (x) => x.descripcion_permiso.toUpperCase() === "CAMBIARPRESTADOR"
            ) > -1;
        },
    }

}
export default comun;